<template>
  <b-card class="siCard">
    <h1 role="heading"
        class="siHead"
        @click="toggleADL"
    >Service Retirement Notice <!-- [182] -->
    </h1>
    <!-- Need to add a <br/> or two HERE when in Portrait -->
    <br v-if="isPortrait" />
    <br v-if="isPortrait" />
    <div class="siContainer">
      <div class="retiredBox">
        <div class="retiredMessage">
          <p>
            This application has been retired and is no longer available for
            account access.
          </p>

          <p>
            The service was formally discontinued following the closure of the
            operating company.
          </p>

          <p class="retiredStrong">
            Please contact your Credit Union with any questions regarding your account<br/>
            or for information on their current Home Bank App.
          </p>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
// import zAuth from './z-auth';

export default {
  components: {
    // zAuth,
  },
  name: 'sign-in',
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      passStyle: 'text-security:disc; -webkit-text-security:disc; -mox-text-security:disc;',
      // [134] Add variable and put -MOX on end
      hiddenPass: 'text-security:disc; -webkit-text-security:disc; -mox-text-security:disc;',
      hidePass: true,
      hidePassCBVisible: true,
      enableSignin: false,
      showSePanel: false,
      seGood: false,
      seChecked: false,
      windowWidth: 0,
      windowHeight: 0,
      canWidth: 560,
      canHeight: 340,
      canMaxWidth: 560,
      canMaxHeight: 680,
      colWidth: 300,
      colHeight: 330,
      siTop: 0,
      siLeft: 0,
      seTop: 0,
      seRight: 0,
      showEnrollmentHelp: false,
      form: {
        type: '',
        user: '',
        pass: '',
        saveAcct: false,
        savePass: false,
      },
      origSaveAcct: false,
      origSavePass: false,
      siInit: 0,
      siRand: '',
      pwRand: '',
      rOnly: false,
      save: {
        user: '',
        pass: '',
        siRand: '',
        pwRand: '',
      },
      userLen: 0,
      passLen: 0,
      seImgUser: 'notValidUser',
      seImgUserValid: false,
      moCount: 0,
      secFormHeight: 0,
      acctChanged: false,
      focusUser: false,
      focusPass: false,
    };
  },
  watch: {
    cun() {
      this.writeDiag(`CU Number Changed - CUN=${this.cun}`);
    },
    seChecked() {
      this.onSecurityCheckBoxChange();
    },
    hidePass() {
      this.onHidePwChange();
    },
    form: {
      handler(val) {
        this.validateSignInButton(val);
      },
      deep: true,
    },
    mySecond() {
      this.intervalSecond();
    },
    myTenth() {
      this.intervalTenthSecond();
    },
    seValid() {
      this.checkSeValid(); // [114] Move code to own routine so can call elsewhere
      /* if (this.seValid === true) {
        utl.diag('seValid = true');
      } else {
        utl.diag('seValid = false');
      } */
      this.validateSignInButton(); // [129] Activates Sign-In button for saved acct click
    },
  },
  computed: {
    isPortrait() {
      return this.$store.getters.getIsPortrait;
    },
    mfaKey() {
      return this.$store.getters.getMfaKey;
    },
    sourceLabel() {
      return this.$store.getters.getSourceHeader;
    },
    showFooter() { // [093]
      return this.$store.getters.getShowFooter;
    },
    otp() { // [091]
      return this.$store.getters.getOTP;
    },
    otKeyK() { // [091]
      return this.$store.getters.getOneTimeKeyK;
    },
    otKeyV() { // [091]
      return this.$store.getters.getOneTimeKeyV;
    },
    isEdge() {
      return this.$store.getters.getIsEdge;
    },
    showUnlockOption() {
      return this.$store.getters.getUnlockOption;
    },
    persist() {
      return this.$store.getters.getPersist;
    },
    returnFromMFA() {
      return this.$store.getters.getReturnFromMFA;
    },
    accountMFA() {
      return this.$store.getters.getAccountMFA;
    },
    doEnroll() {
      return this.$store.getters.getDoEnroll;
    },
    myTenth() {
      return this.$store.getters.getMyTenth;
    },
    mySecond() {
      return this.$store.getters.getMySecond;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    seImg() {
      return this.$store.getters.getSeImage;
    },
    seValid() {
      return this.$store.getters.getSeImageValid;
    },
    adlValid() {
      return this.$store.getters.getAccountsDropListValid;
    },
    accounts() {
      return this.$store.getters.getAccountsList;
    },
    saveValid() {
      return this.$store.getters.getSavActPasFlag;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
  },
  methods: {
    checkSeValid() { // [114] Move here and call from WATCH seValid()
      if (this.form.user.trim().length === 0) {
        this.setImgInvalid();
        return;
      }
      if (this.seValid === true) {
        // utl.diag('p00: seValid === true');
        this.seImgUser = this.form.user;
        this.seImgUserValid = true;
        if (this.secFormHeight === 0) {
          const container = document.querySelector('#ptMain');
          this.secFormHeight = container.scrollHeight;
          // Validate here so catches saved accts w/ security Image (disable Sign-In)
          this.validateSignInButton();
        }
      } else {
        this.setImgInvalid();
      }
    },
    setImgInvalid() {
      // utl.diag('p00: seValid === false');
      this.secFormHeight = 0;
      this.seImgUser = 'notValidUser';
      this.seImgUserValid = false;
    },
    getStorage(key) {
      return this.persist[key];
    },
    toggleADL() {
      // this.$store.commit('setAccountDropDownValid', !this.adlValid);
    },
    intervalTenthSecond() {
      if (this.focusUser === true) {
        this.focusUser = false;
        this.$refs.siUser.$el.focus(); // Set Focus on element with ref="siUser"
      }
      if (this.focusPass === true) {
        this.focusPass = false;
        this.$refs.siPass.$el.focus(); // Set Focus on element with ref="siPass"
      }

      if (this.secFormHeight > 0) {
        const container = document.querySelector('#ptMain');
        const curHeight = container.scrollHeight;
        if (this.secFormHeight !== curHeight) {
          this.secFormHeight = curHeight;
          window.scrollTo(0, curHeight); // Scroll to end of page after Image Displayed
          // utl.diag(`second-Height: ${curHeight}`);
        }
      }

      if (this.siInit === 0) {
        this.siInit = 1;
        // utl.diag('siInit===0');
      } else if (this.siInit === 1) {
        this.siInit = 2;
        const myDate = +new Date();
        this.siRand = `si${myDate}`;
        this.pwRand = `pw${myDate}`;
        // utl.diag(`Tenth siRand = ${this.siRand}`);
        // utl.diag(`Tenth pwRand = ${this.pwRand}`);
      }

      /*
      if (this.ronly === true) {
        this.ronly = false; // Initial ReadOnly on acct prevents autocomplete
      }
      */
    },
    intervalSecond() {
      if ((this.save.user !== this.form.user) ||
        (this.save.pass !== this.form.pass) ||
        (this.save.siRand !== this.siRand) ||
        (this.save.pwRand !== this.pwRand)) {
        // utl.diag(`mySec siRand = ${this.siRand}`);
        // utl.diag(`mySec pwRand = ${this.pwRand}`);
        // utl.diag(`mySec User   = ${this.form.user}`);
        // utl.diag(`mySec Pass   = ${this.form.pass}`);
        this.save.user = this.form.user;
        this.save.pass = this.form.pass;
        this.save.siRand = this.siRand;
        this.save.pwRand = this.pwRand;
      }
      //
    },
    updateSePanel(opt) {
      this.writeDiag(`Called updateSePanel: ${opt}`);
      /* if (this.seImg.imgValid !== this.showSePanel) {
        this.showSePanel = this.seImg.imgValid;
        if (this.showSePanel) {
          if (this.seGood) {
            // not used yet
          }
        }
        this.resize();
      } */
    },
    siOver() {
      this.moCount += 1;
    },
    signIn() {
      if (!this.enableSignin) {
        this.writeDiag('SignIn Button is disabled');
        if (this.userLen === 0) {
          this.showAlert('Please Enter a valid user/acct');
          return;
        }
        if (this.passLen === 0) {
          this.showAlert('Please Enter a valid Password');
          return;
        }
        if (this.seImg.imgValid && !this.seChecked) {
          this.showAlert('Please Check the image/caption');
        }
      } else {
        this.hideAlert();
        this.hideConfirm();
        this.form.type = 'login';
        this.writeDiag(`Login for User: ${this.form.user}`);
        this.$store.commit('setUserPass', `${this.form.user} ${this.form.pass}`); // Space Delimited
        // this.$emit('result', this.form);
        this.loginResult(this.form);
        // this.writeLocal('acct', this.form.user);
      }
    },

    loginResult(form) {
      if (form.type === 'login') {
        this.lrSignIn(form);
      }
      if (form.type === 'enroll') {
        this.lrEnroll(form);
      }
      if (form.type === 'forgot') {
        this.lrForgot(form);
      }
    },
    lrForgot() {
      this.verHead = 'Forgot Password';
      this.$store.commit('setPageIndex', 2);
    },
    lrEnroll(form) {
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = form.user;
      this.wsSend('c4FullPing', cuInfo);
    },
    lrSignIn(form) {
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = form.user;
      cuInfo.siUser = ''; // Not a valid option (yet)
      cuInfo.siPass = form.pass;
      cuInfo.siSaveUser = form.saveAcct;
      cuInfo.siSavePass = form.savePass;
      cuInfo.navVer = this.navVer;
      cuInfo.mfaKey = this.mfaKey; // [138] set by getSecurityImage

      this.form.pass = ''; // Blank this out so Browser doesn't try to save it
      this.showPW(); // Don't hide, so Browser doesn't know it's a password
      this.wsSend('c4SignIn', cuInfo);
    },

    /* enroll() {
      if (this.cun === 22000) {
        if (this.form.user === '1520') {
          this.passType = 'password';
          this.form.pass = 'pt123456';
          this.enableSignin = true;
          this.$store.commit('setDiag22000', true);
          this.signIn();
        } else {
          // this.diag('Enter test acct number and press tab, then click ENROLL');
          this.showAlert('Enroll is not implemented yet');
          this.$store.commit('setDiag22000', false);
        }
      }
    }, */
    forgot() {
      this.hideAlert();
      this.hideConfirm();
      const myUser = `${this.form.user}`; // make sure is string for next line
      const acLen = myUser.trim().length;
      if (acLen === 0) {
        this.showAlert('Enter account number before clicking Forgot Password');
        this.$refs.siUser.$el.focus(); // Set Focus on element with ref="siUser"
        return;
      }
      // this.showAlert('Forgot Password got here');
      // this.form.type = 'forgot';
      // this.$emit('result', this.form);
      // this.$store.commit('setTestXFR');
      this.$store.commit('setPwChangeOption', 1); // 1=forgot password
      this.$store.commit('setPageIndex', 13);
      this.writeDiag(`ForgotPass: Acct=${this.siFormUser}`);
    },
    unlock() {
      this.hideAlert();
      this.hideConfirm();
      const myUser = this.form.user;
      const acLen = myUser.trim().length;
      if (acLen === 0) {
        this.showAlert('Enter account number before clicking Forgot Password');
        this.$refs.siUser.$el.focus(); // Set Focus on element with ref="siUser"
        return;
      }
      // this.showAlert('Unlock Account got here');
      this.$store.commit('setPwChangeOption', 2); // 2=Unlock Account
      this.$store.commit('setPageIndex', 14);
      this.writeDiag(`UnlockAccount: Acct=${this.siFormUser}`);
    },
    eHelp() {
      this.showEnrollmentHelp = !this.showEnrollmentHelp;
    },
    doConnect() {
      this.$store.commit('wsConnect');
    },
    doDisconnect() {
      this.$store.commit('wsDisconnect');
    },
    myImage() {
      // this.enableSignin = this.seGood;
    },
    imgClick(event) {
      /* utl.diag(event); */
      // eslint-disable-next-line
      const msg = 'h: ' + String(event.srcElement.clientHeight) +
        ' w: ' + String(event.srcElement.clientWidth) +
        ' X: ' + String(event.offsetX) +
        ' Y: ' + String(event.offsetY);
      this.diag(msg);
    },
    diag(message) {
      // this.$emit('diag', message);
      this.$store.commit('showDiag', `: ${message}`);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', `p00: ${message}`);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    siGotFocus() {
      // utl.diag('siGotFocus');
    },
    pwGotFocus() {
      this.updatePwVisible();
      /*
      if (this.isEdge) {
        const x = document.getElementById('siPass');
        if (this.hidePass === true) {
          x.type = 'password';
          this.passStyle = '';
        } else {
          x.type = 'text';
          this.passStyle = '';
        }
      } */
      // utl.diag('pwGotFocus');
      if (this.acctChanged) {
        this.acctChanged = false;
        this.requestSecurityImage();
      }
    },
    clickedSignInLabel() {
      // this.$store.commit('setShowFooter', !this.showFooter);
      /*
      const cuList = utl.getCuList(this.persist);
      utl.diag(cuList);
      */
    },
    onBlurAccount() {
      // this.writeDiag('onBlurAccount fired');
      // utl.diag('siLostFocus');
      // utl.diag(`BlurA siRand = ${this.siRand}`);
      // utl.diag(`BlurA pwRand = ${this.pwRand}`);

      if (this.acctChanged) {
        this.acctChanged = false;
        this.$store.commit('setSiFormUser', this.form.user);
        // const pkAct = utl.pakAct(this.cun, this.form.user);
        // this.$store.commit('setPkAct', pkAct);
        this.writeDiag(`onBlurAccount=${this.form.user}`);
        // utl.diag(`onBlurAccount=${this.form.user}`);
        this.requestSecurityImage();
      }
      if (typeof this.$refs.siPass !== 'undefined') { // Not defined while MFA page is displayed
        // this.$refs.siPass.$el.focus(); // Set Focus on element with ref="siPass"
      }
      this.checkSeValid(); // [114] Check here instead of depending on WATCH seValid
    },
    onBlurPassword() {
      // utl.diag('pwLostFocus');
    },
    requestSecurityImage() {
      if (this.form.user !== this.seImgUser) {
        if (`${this.form.user} `.trim().length > 0) {
          const pkAct = utl.pakAct(this.cun, this.form.user);
          this.$store.commit('setPkAct', pkAct);
          this.writeDiag(`requestSecurityImage() - pkAct: ${pkAct}`);
          const cuInfo = {};
          cuInfo.cun = this.cun;
          cuInfo.acct = this.form.user;
          cuInfo.mfaKey = null;
          this.writeDiag(`otKeyK: "${this.otKeyK}"`);
          this.writeDiag(`otKeyV: "${this.otKeyV}"`);

          if ((this.otp === true) && (this.otKeyK === pkAct)) { // [191]
            cuInfo.mfaKey = this.otKeyV;
            this.$store.commit('clrOneTimeKey'); // [191] Can only be used one time (we just used it)
          }

          if ((typeof cuInfo.mfaKey === 'undefined') || (cuInfo.mfaKey === null)) {
            cuInfo.mfaKey = utl.getAcctToken(this.$store.commit, this.$store.state, pkAct);
          }
          this.$store.commit('setMfaKey', cuInfo.mfaKey); // [138]
          this.writeDiag(`mfaKey: "${cuInfo.mfaKey}"`);

          if ((typeof cuInfo.mfaKey === 'undefined') || (cuInfo.mfaKey === null)) {
            this.$store.commit('setSiFormUser', this.form.user);
            cuInfo.mfaKey = 'Not Set';
            // this.$store.commit('setMfaForm', true);
            this.writeDiag('mfaKey: undefined - setPageIndex = 6');
            this.$store.commit('setPageIndex', 6);
            return;
          }
          // utl.diag(`mfaKey='${cuInfo.mfaKey}'`);
          this.wsSend('c4GetSecurityImage', cuInfo);
          // utl.diag(`Request Security Image - CU=${this.cun} User=${this.form.user}`);
        } else {
          // utl.diag(`Request Security Image - CU=${this.cun} User=BLANK`);
        }
      }
    },
    onUserChange() {
      // this.$store.commit('putDiag', 'onUserChange fired');
      this.acctChanged = true;
      if ((this.seImgUserValid === true) && (this.seImgUser === this.form.user)) {
        this.$store.commit('setShowFooter', true);
      } else {
        this.$store.commit('setShowFooter', false);
      }
    },
    aClick(i) { // [128] Added
      this.onUserSelectChange(i.value);
    },
    onUserSelectChange(acct) {
      this.form.user = acct; // Put the acct number in form.user
      this.form.pass = ''; // Not known yet
      // utl.diag(`onUserSelectChange - siUser="${this.form.user}"`);
      // utl.diag(`onUserSelectChange(${acct})`);
      this.acctChanged = true;
      let found = false;
      for (let i = 0; i < this.accounts.length; i += 1) {
        if (this.accounts[i].text === acct) {
          found = true;
          this.form.saveAcct = this.accounts[i].saveAcct; // It was saved, flag to save it again
          this.form.savePass = this.accounts[i].savePass; // It was saved, flag to save it again
          if (this.accounts[i].pw.length > 0) {
            // Don't allow saved passwords to be shown (hide and remove the hide checkbox)
            this.hidePass = true;
            this.passStyle = this.hiddenPass;
            this.hidePassCBVisible = false; // make the hidePass checkbox invisible
            this.form.pass = this.accounts[i].pw;
          }
          // this doesn't work at this point
          // this.validateSignInButton(); // Enable or Disable Sign-In button
        }
        if (found === true) { break; }
      }
      this.onBlurAccount();
      if (typeof this.$refs.siPass !== 'undefined') { // Not defined while MFA page is displayed
        this.$refs.siPass.focus(); // Set Focus on element with ref="siPass"
      }
    },
    onHidePwChange() {
      this.updatePwVisible();
      /*
      if (this.isEdge) {
        const x = document.getElementById('siPass');
        if (this.hidePass === true) {
          x.type = 'password';
          this.passStyle = '';
        } else {
          x.type = 'text';
          this.passStyle = '';
        }
      } else {
        if (this.hidePass === true) {
          this.passStyle = this.hiddenPass;
        } else {
          this.passStyle = '';
        }
      } */
    },
    updatePwVisible() {
      if (this.hidePass === true) {
        this.hidePW();
      } else {
        this.showPW();
      }
    },
    hidePW() {
      const x = document.getElementById('siPass');
      x.type = 'text'; // [134]
      this.passStyle = this.hiddenPass; // [134]
      // if (this.isEdge) {
      // x.type = 'password';
      // this.passStyle = '';
      // this.diag('eHide PW');
      // } else {
      // this.passStyle = this.hiddenPass;
      // this.diag('Hide PW');
      // }
    },
    showPW() {
      // if (this.isEdge) {
      const x = document.getElementById('siPass');
      x.type = 'text';
      this.passStyle = '';
      // this.diag('eShow PW');
      // }
      // if (!this.isEdge) {
      // this.passStyle = '';
      // this.diag('Show PW');
      // }
    },
    onSecurityCheckBoxChange() {
      this.validateSignInButton();
    },
    validateSignInButton() {
      this.hideAlert();
      let valid = true;
      this.userLen = `${this.form.user} `.trim().length;
      this.passLen = `${this.form.pass} `.trim().length;
      if (this.userLen === 0) valid = false;
      if (this.passLen === 0) valid = false;
      if (this.seImg.imgValid) {
        if (!this.seChecked) valid = false;
      }
      this.enableSignin = valid;
      // utl.diag(`vsib: user: ${this.form.user}`);
      // utl.diag(`vsib: pass: ${this.form.pass}`);

      // form.saveAcct and form.savePass changes trigger validateSignInButton
      this.updateSaveBoxes();
    },
    updateSaveBoxes() {
      if (this.form.saveAcct !== this.origSaveAcct) {
        this.onSaveAcctChange();
      }
      if (this.form.savePass !== this.origSavePass) {
        this.onSavePassChange();
      }
    },
    onSaveAcctChange() {
      this.origSaveAcct = this.form.saveAcct;
      if (this.form.saveAcct === false) {
        this.form.savePass = false;
      }
    },
    onSavePassChange() {
      this.origSavePass = this.form.savePass;
      if (this.form.savePass === true) {
        this.form.saveAcct = true;
      }
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    writeLocal(myKey, myValue) {
      const locInfo = {};
      locInfo.key = myKey;
      locInfo.value = myValue;
      this.$store.commit('saveLocal', locInfo);
    },
    hideConfirm() {
      this.$store.commit('setConfirmShow', false);
    },
    hideAlert() {
      this.$store.commit('setAlertShow', false);
    },
    // eslint-disable-next-line
    handleKeyStroke(event) {
      let keyCode = event.keyCode;
      const e1 = document.activeElement;
      // utl.diag(`enroll-keyPressed: ${event.keyCode}`);
      // utl.diag('Focused Element:');
      // utl.diag(e1);
      if (keyCode === 13) { // Enter Pressed
        // utl.diag('p00-signin: Enter Pressed');
        // utl.diag(`e1.name="${e1.name}"`);
        keyCode = 0;
        event.preventDefault();
        event.stopPropagation(true);
        if (e1.name === this.siRand) this.$refs.siPass.focus();
      }
    },

  },
  mounted() {
    // utl.diag('p00-signin: Mounted()');
    // utl.diag(`returnFromMFA: ${this.returnFromMFA}`);
    // utl.diag(`accountMFA: ${this.accountMFA}`);
    if (this.returnFromMFA === true) {
      const doEnroll = this.doEnroll; // Copy this because will change below
      this.form.type = '';
      this.form.pass = '';
      this.form.user = this.accountMFA;
      this.acctChanged = true;
      this.focusPass = true;
      this.$store.commit('setReturnFromMFA', false);
      this.$store.commit('setDoEnroll', false);
      this.$store.commit('setAccountMFA', '');
      this.$store.commit('setShowFooter', false);
      // utl.diag(`set MFA info - Acct: ${this.form.user}`);
      if (doEnroll === true) {
        this.$store.commit('setPageIndex', 15); // Goto Enroll Page
      }
      return;
    }
    this.hidePassCBVisible = true;
    const myDate = +new Date();
    this.siRand = `si${myDate}`;
    this.pwRand = `pw${myDate}`;
    // utl.diag(`mount siRand = ${this.siRand}`);
    // utl.diag(`mount pwRand = ${this.pwRand}`);
    if (typeof this.$refs.siUser !== 'undefined') { // Not defined while MFA page is displayed
      this.$refs.siUser.$el.focus(); // Set Focus on element with ref="siUser"
    }
  },
  created() {
    window.addEventListener('keypress', this.handleKeyStroke);
  },
  destroyed() {
    window.removeEventListener('keypress', this.handleKeyStroke);
  },
};

</script>

<style scoped>
  .siCard {
    /* position: relative; */
    margin: 10px;
    /* display: inline-block; */
    background: lightyellow;
  }
  .siHead {
    /* position: relative; */
    height: 40px;
    top: -10px;
    font-weight: bold;
  }
  .siContainer {
    display: block;          /* NOT flex */
    padding: 10px;
  }
  #siCol {
    /* position: absolute; */
    /* height: 330px; */
    /* position: relative;
    display: inline-block;
    width: 300px;
    height: 330px; */
    margin: auto;
    border: solid 4px black;
  }
  .retiredBox {
    width: calc(100% - 20px); /* 10px each side */
    margin: 10px auto;
    padding: 20px;
    border: solid 4px black;
    background-color: #ffffff;
    box-sizing: border-box;
  }

  .retiredMessage {
    text-align: center;
    color: black;
    font-size: 18px;
  }

  .retiredMessage h3 {
    font-weight: bold;
    margin-bottom: 20px;
  }
  .retiredStrong {
    font-weight: bold;
    margin-top: 20px;
  }

  #siPlease {
    font-weight: bold;
    font-size: 24px;
    color: blue;
  }
  #btnSi {
    background-color: lime;
    color: black;
    font-weight: bold;
    /* left: -10px; */
  }
  #btnEn {
    background-color: yellow;
    color: black;
    font-weight: bold;
    right: -10px;
  }

  #hiPass {
    position: relative;
    left: -500px;
  }
  #seCol {
    /* position: absolute; */
    /* height: 330px; */
    /* display: inline-block;
    width: 300px;
    height: 330px; */
    /* border: solid 1px black; */
  }
  #secHeader {
    color: red;
    font-weight: bold;
    font-size: 24px;
  }
  .seCheckBox {
    color: red;
    font-weight: bold;
    margin-bottom: 8px;
  }
  #imageSrc {
    /*
    position: relative;
    height: 200px;
    width:  200px; */
  }
  #imageCap {
    font-family: "Courier New", serif;
    font-size: 16px;
  }
  #forgot {
    /* position: relative; */
    /* bottom: -30px; */
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  #unlock {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  #ehelp {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  .acctBox {
    position: relative;
    display: inline-block;
    /* horiz-align: center; */
    width: 298px;
    height: 42px;
    /* border: solid 1px blue; */
    background-color: white;
    /* margin-bottom: 40px; */
  }
  .acctInput {
    position: absolute;
    top: 1px;
    left: 1px;
    height: 38px;
    font-size: 16px;
    width: 294px;
    /* border: solid 1px blue; */
    z-index: 100;
  }
  #siPass {
    margin-left: 1px;
    width: 296px;
  }
  .acctSelect {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 16px;
    width: 296px;
    height: 40px;
    /* border: solid 1px blue; */
    z-index: 98;
  }
  .siForm {
    /* border: solid 1px blue; */
  }
  * {
    margin: 0;
  }
  .svCheck {
    position: relative;
    display: inline-block;
    /* border: solid 1px blue; */
  }
  .svItem {
    position: relative;
    display: inline-block;
    left: 0;
  }
  #dropdown-accounts {
    position: relative;
    left: 122px;
    top: -6px;
    height: 36px;
    width: 20px;
    z-index: 200;
  }
  .dropHead { /* Account Header in drop-down */
    background-color: blue;
    color: white;
    font-weight: bold;
    width: 100px;
  }
  .dropItem { /* Account Item in drop-down */
    padding-left: 20px;
    background-color: white;
    color: black;
    font-weight: bold;
    width: 100px;
  }
  .helpBox {
    position: relative;
    background-color: white;
    border: solid 2px red;
    padding-top: 4px;
    padding-bottom: 4px;
    min-width: 300px;
  }
  .helpBoxTitle {
    color: blue;
    font-size: 24px;
    font-weight: bold;
    margin: auto;
    text-decoration: underline;
    cursor: pointer;
  }
  .helpBoxLeft {
    background-color: white;
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
  }
  .btnSmallGreen {
    background-color: lime;
    color: black;
    font-size: 10px;
    font-weight: bold;
    top: 10px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/p00-signIn.vue